import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/FullscreenRounded';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExitRounded';
import useFullscreenPreview from '../../Preview/useFullscreenPreview';
import { trackEvent, AnalyticsConstants } from '../../../../../utilities/analyticsUtilities';

const FullscreenPreviewButton = () => {
    const { isSupported, isFullscreen, toggleFullscreen } = useFullscreenPreview();

    // A button that does nothing is worse than none.
    if (!isSupported)
        return null;

    const label = isFullscreen ? 'Exit Full Screen' : 'Full Screen';

    // Tracked here rather than in the shared hook, so the Features panel switch only sends its
    // own Enabled Feature event.
    const handleClick = () => {
        if (!isFullscreen) {
            trackEvent('Opened Fullscreen', {
                category: AnalyticsConstants.VIDEO_CATEGORY
            });
        }

        toggleFullscreen();
    };

    return (
        <Tooltip title={label} placement='top' arrow>
            <IconButton onClick={handleClick} aria-label={label} size='large'>
                {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </IconButton>
        </Tooltip>
    );
};

export default FullscreenPreviewButton;
